import { Stack, StackProps } from "./Stack";

export const Row = (props: Omit<StackProps, "direction">) => (
  <Stack direction="row" {...props} />
);
